export const PHONE_COLORS = {
  WHITE: 'white',
  BLACK: 'black',
  GREEN: 'green',
  BLUE: 'blue',
  GREY: 'grey',
  GREEN_REVERSE: 'green_reverse',
  BLUE_REVERSE: 'blue_reverse',
  GREY_REVERSE: 'grey_reverse',
  RED: 'red',
  RED_REVERSE: 'red_reverse',
  PURPLE: 'purple',
};

export const VIEW_OPTIONS = {
  BUTTON: 'button',
  PHONE: 'phoneNumber',
};

export const KIND = {
  PHONE: 'telefono',
  C2C: 'c2c',
};

export const printStates = [
  'SCX_CAMPAIGN_READY',
  'WM_900_READY',
  'SCX_CAMPAIGN_ERROR',
  'SCX_BACKEND_REQUEST_ERROR',
];

export const SCX_ROUTE = {
  QA: 'https://qa.cms.col.movistar.es/static/js/scx/scx.js',
  PROD: 'https://prod.cms.col.movistar.es/static/js/scx/scx.js',
};

export const CALL_4_SELLING_CONTENT = {
  C2C: 'te-llamamos',
  T900: 'llama-gratis',
};
